import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';
import Modal from 'flarum/common/components/Modal';
import ModalManager from 'flarum/common/components/ModalManager';
import ModalManagerState from 'flarum/common/states/ModalManagerState';
import coreSearchPage from './coreSearchPage';
import IgnoreSearchUser from './IgnoreSearchUser';
import IgnoreMentions from "./IgnoreMentions";
import modifyDiscussionItem from './modifyDiscussionItem';
import modifyTagSelectionModal from './modifyTagSelectionModal';
import modifyNavigation from './modifyNavigation';
import modifyApplication from './modifyApplication';
import modifyHeaderSecondary from './modifyHeaderSecondary';
import modifyDrawer from './modifyDrawer';
// v0.5.0 (Trello 卡 6a7e65df8eb1684c9d8b78f8): 手机号登录 extend 覆盖 vendor LogInModal
import phoneLoginExtension from './components/PhoneLogin';
// v0.5.2 (Trello 卡 6a7fc343f990e73904af2c75): 手机号注册 extend 覆盖 vendor SignUpModal
import signUpExtension from './components/SignUp';
// v0.5.3 (Trello 卡 6a7fcee8778d13c624d2acdc, 辉哥 11:51 拍板 go): 手机号找回密码 extend 覆盖 vendor ForgotPasswordModal
import forgotPasswordExtension from './components/ForgotPassword';

// FancyBox 本地路径 (6.x 需要加载多个 CSS 文件)
const FANCYBOX_CSS_PATHS = ['/assets/extensions/ziiven-ziven-core/fancyBox/fancybox.css'
// '/assets/extensions/ziiven-dress-up/fancybox/carousel.css',
// '/assets/extensions/ziiven-dress-up/fancybox/fullscreen.css'
];
const FANCYBOX_JS = '/assets/extensions/ziiven-ziven-core/fancyBox/fancybox.umd.js';
let fancyboxLoaded = false;
let fancyboxLoading = false;

// 动态加载 FancyBox 资源
function loadFancyBox() {
  if (fancyboxLoaded || fancyboxLoading) return;
  fancyboxLoading = true;

  // 加载所有 CSS 文件
  FANCYBOX_CSS_PATHS.forEach(function (cssPath) {
    if (!document.querySelector('link[href="' + cssPath + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssPath;
      document.head.appendChild(link);
    }
  });

  // 加载 JS
  if (!document.querySelector('script[src="' + FANCYBOX_JS + '"]')) {
    var script = document.createElement('script');
    script.src = FANCYBOX_JS;
    script.onload = function () {
      fancyboxLoaded = true;
      fancyboxLoading = false;
      console.log('FancyBox loaded successfully');
    };
    script.onerror = function (e) {
      fancyboxLoading = false;
      console.error('FancyBox load error:', e);
    };
    document.head.appendChild(script);
  } else {
    fancyboxLoaded = true;
  }
}

// 打开 FancyBox 预览
function openFancyBox(src, options) {
  options = options || {};

  // 确保 FancyBox 已加载
  if (!window.Fancybox) {
    loadFancyBox();
    // 延迟执行，等待加载完成
    var attempts = 0;
    var checkInterval = setInterval(function () {
      attempts++;
      if (window.Fancybox) {
        clearInterval(checkInterval);
        doOpenFancybox(src, options);
      } else if (attempts > 50) {
        clearInterval(checkInterval);
        console.error('FancyBox load timeout');
      }
    }, 100);
  } else {
    doOpenFancybox(src, options);
  }
}

// 执行打开 FancyBox
function doOpenFancybox(src, options) {
  if (window.Fancybox) {
    window.Fancybox.show([{
      src: src,
      type: 'image'
    }], {
      dragToClose: false
    });
  }
}
app.initializers.add('ziven-core', () => {
  // 预加载 FancyBox (静默加载，不阻塞页面)
  loadFancyBox();

  // v0.5.0 (Trello 卡 6a7e65df8eb1684c9d8b78f8): 加载手机号登录 extension
  // (覆盖 vendor LogInModal 加 phone tab 切换, 辉哥 08:47 拍板 2A extend 模式)
  phoneLoginExtension();

  // v0.5.2 (Trello 卡 6a7fc343f990e73904af2c75): 加载手机号注册 extension
  // (覆盖 vendor SignUpModal 加 phone tab 切换, 跟 v0.5.0/0.5.1 模式一致)
  signUpExtension();

  // v0.5.3 (Trello 卡 6a7fcee8778d13c624d2acdc, 辉哥 11:51 拍板 go): 加载手机号找回密码 extension
  // (覆盖 vendor ForgotPasswordModal 加 phone tab 切换 + 子 tab 验证码/旧密码, 跟 v0.5.0/0.5.1/0.5.2 模式一致)
  forgotPasswordExtension();
  User.prototype.ignore_all = Model.attribute('ignore_all');
  app.routes['search'] = {
    path: '/search',
    component: coreSearchPage
  };

  // 注册 Fancybox 工具函数
  app.fancyboxOpen = function (src, options) {
    if (options === void 0) {
      options = {};
    }
    openFancyBox(src, options);
  };
  extend(Modal.prototype, 'onready', function (params) {
    $(".ModalManager-invisibleBackdrop").off("click");
  });

  // v0.5.8 / Trello 卡 6a92e0d646d27a832fb339ea (辉哥 8/29 21:35 调研确认, 21:37 拍板修法 A):
  //   根因: iOS 14+ modal 打开瞬间页面跳顶部. vendor FormModal.onready 触发 input focus
  //     让 iOS 14+ input focus + position:fixed body 行为互相抵消, scrollY 锁定在 input
  //     位置 (modal 中间). BookingModal extends Modal (不 extends FormModal), Modal.onready
  //     是空, iOS 14+ body-scroll-lock 库 iOS 13+ technique 失效把 scrollY reset 到 0.
  //   修法: 全局 override Modal.prototype.onready 强制所有 modal 触发首个 input focus,
  //     跟 LogInModal 路径一致. 跨项目覆盖所有 modal (LogInModal / SignUpModal /
  //     ForgotPasswordModal / TagSelectionModal / BookingModal / 任何第三方 modal).
  //   安全性: LogInModal 已有 FormModal.onready 触发 focus, 我们的 override 跑 super (空) +
  //     我们的 focus, 双重 focus 不会报错 (jQuery trigger focus 重复触发 noop).
  //   保留 v0.5.5/5.6/5.7.1 既有兑底链 (animateHide 3 rAF + ModalManagerState.close 4 rAF
  //     + setTimeout 50/200/1000 + documentElement.scrollTop).
  override(Modal.prototype, 'onready', function (original) {
    original(); // Modal.onready 是空, FormModal 子类会调到 FormModal.onready (input focus)
    // 跨项目统一: 强制所有 modal 触发首个 input focus, 跟 LogInModal 路径一致
    // 修 iOS 14+ body-scroll-lock 库 iOS 13+ technique 失效导致 modal 打开瞬间 scrollY reset 到 0
    const $el = this.$ && this.$();
    if ($el && $el.find) {
      const $input = $el.find('input, select, textarea').first();
      if ($input.length) {
        $input.trigger('focus').trigger('select');
      }
    }
  });

  // v0.4.9c: 删 pull-to-refresh-js init
  // 1.x 时代遗留, 微信 X5 下拉触发 preventDefault → onRefresh → location.reload()
  // → 视觉上"松手弹回顶部" (辉哥 11:32 反馈, 拍板 A 方案删除)
  // mithril 2.x 也不需要 pull-to-refresh UI, Flarum 自带 nav 已经是 SPA

  modifyApplication();
  modifyHeaderSecondary();
  modifyNavigation();
  modifyDiscussionItem();
  modifyTagSelectionModal();
  modifyDrawer();
  /** 用户搜索 黑名单过滤 */
  IgnoreSearchUser();
  /** 富文本 推荐名单过滤  */
  IgnoreMentions();

  /*
  let calendarTranApi = document.createElement('script');
  calendarTranApi.charset = 'utf-8';
  calendarTranApi.src = '/assets/extensions/ziiven-ziven-core/calender/calendar.translations.zh.js';
  document.head.appendChild(calendarTranApi);
    let calendarApi = document.createElement('script');
  calendarApi.charset = 'utf-8';
  calendarApi.src = '/assets/extensions/ziiven-ziven-core/calender/calendar.min.js';
  document.head.appendChild(calendarApi);
    const head  = document.getElementsByTagName('head')[0];
  const calendarLink  = document.createElement('link');
  calendarLink.rel  = 'stylesheet';
  calendarLink.type = 'text/css';
  calendarLink.href = '/assets/extensions/ziiven-ziven-core/calender/calendar.js.min.css';
  calendarLink.media = 'all';
  head.appendChild(calendarLink);
    let flatpickrApi = document.createElement('script');
  flatpickrApi.charset = 'utf-8';
  flatpickrApi.src = '/assets/extensions/ziiven-ziven-core/flatpickr/flatpickr.js';
  document.head.appendChild(flatpickrApi);
    const flatpickrLink  = document.createElement('link');
  flatpickrLink.rel  = 'stylesheet';
  flatpickrLink.type = 'text/css';
  flatpickrLink.href = '/assets/extensions/ziiven-ziven-core/flatpickr/flatpickr.min.css';
  flatpickrLink.media = 'all';
  head.appendChild(flatpickrLink);
  */

  window.onpopstate = history.onpushstate = function (e) {
    app.composer.hide();
  };
  $.fn.isInViewport = function () {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  $(window).on('resize scroll', function () {
    $('[class$="loadMore"] button').each(function () {
      if ($(this).isInViewport()) {
        $(this).click();
      }
    });
  });
});
export * from '../common';